<template>
    <div class="token-input">
        <div class="token-input__field">
            <div class="token-input__tokens">
                <span v-if="!localTokens.length" class="token-input__placeholder">
                    Select tokens below
                </span>
                <div v-for="(token, index) in localTokens" :key="index" class="token-input__token">
                    <div class="token-input__value">{{ tokenLabel(token[0]) }}</div>
                    <button
                        class="button button--blank token-input__delete"
                        type="button"
                        @click="remove(index)"
                    >
                        ✕
                    </button>
                    <div v-if="delimiter">{{ delimiter }}</div>
                </div>
            </div>
        </div>
        <div class="token-input__row">
            <ul class="token-input__tokens">
                <li
                    v-for="(option, index) in tokens"
                    :key="index"
                    class="token-input__token token-input__token--option"
                    @click.prevent="type(option)"
                >
                    <slot name="option" :token="option">
                        {{ tokenLabel(option) }}
                    </slot>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TokenInput',
    emits: ['update:modelValue'],
    props: {
        tokens: {
            type: Array,
            default: () => []
        },
        delimiter: {
            type: String,
            default: ''
        },
        modelValue: {
            type: String,
            default: ''
        },
        labels: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            localTokens: []
        };
    },

    computed: {
        regexp() {
            return new RegExp(this.tokens.map(t => `(${t})`).join('|'), 'g');
        },
        final() {
            return this.localTokens.join(this.delimiter);
        }
    },

    watch: {
        modelValue: {
            immediate: true,
            handler() {
                this.parse();
            }
        }
    },

    methods: {
        parse() {
            if (!this.modelValue) return;

            this.localTokens = Array.from(this.modelValue.matchAll(this.regexp)).map(m => m[0]);
        },
        type(token) {
            this.localTokens.push(token);

            this.update();
        },
        remove(index) {
            this.localTokens.splice(index, 1);

            this.update();
        },
        tokenLabel(token) {
            const { [token]: label = { eng: token, rus: token } } = this.labels;

            return label[this.$i18n.locale];
        },

        update() {
            this.$emit('update:modelValue', this.final);
        }
    }
};
</script>

<style src="./TokenInput.scss" lang="scss"></style>
